const n = (e, r = "en-US", t = "USD") => new Intl.NumberFormat(r, { style: "currency", currency: t }).format(e ?? 0), o = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCurrency: n
}, Symbol.toStringTag, { value: "Module" }));
export {
  n as f,
  o as n
};
